<template>
  <div :style="style" class="relative overflow-hidden">
    <!-- dikey resimler icin -->
    <div v-if="style.height === 'auto'" style="padding-bottom: 56.25%"></div>
    <OImage
      v-if="isVideoArticle"
      loading="lazy"
      src="/images/video-play-button.svg"
      class="absolute z-1 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 h-2/5 w-2/5 pointer-events-none"
    />
    <OImage ref="imgEl" loading="lazy" :src="imgUrl" class="absolute top-0 left-0 w-full h-full object-cover" :alt="article.title" />
  </div>
</template>

<script>
import { defineComponent, ref, computed } from '@nuxtjs/composition-api';
import { articleCardSizes } from './articleCardUtils';
import { hasArticleCategory } from '~/modules/article/utils/articleUtils';
import { getImageUrl } from '~/modules/common/utils/imageUtils';
import { OImage } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OImage },
  props: {
    article: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'default',
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  setup(props) {
    const imgEl = ref(null);
    const size = computed(() => articleCardSizes[props.size]);
    // INFO: anasayfada tekli ve ikili gelen articlelar için genişlik hesabı
    let fullSizeWidth = 620; // mobile max width - padding
    if (process.client) {
      fullSizeWidth = props.fullWidth ? window.innerWidth - 20 : (window.innerWidth - 30) / 2;
      fullSizeWidth = fullSizeWidth - (fullSizeWidth % 50) + 50;
    }
    const width = props.size === 'full' ? fullSizeWidth : size.value?.width.replace('px', '');
    const height = props.size === 'full' ? null : size.value?.height.replace('px', '');
    const imgUrl = ref(getImageUrl(props.article?.image, { width, height }) || '');
    const isVideoArticle = hasArticleCategory(props.article, 'Video');
    const style = computed(() => ({ width: '100%', maxWidth: size.value.width, minWidth: '100px', height: size.value.height }));
    return { imgEl, imgUrl, style, isVideoArticle };
  },
});
</script>
